import LegalLayout, { Section } from "./LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Polityka prywatności" lastUpdated="28 maja 2026">
      <p className="text-base">
        Niniejszy dokument opisuje zasady przetwarzania danych osobowych użytkowników serwisu
        internetowego prowadzonego pod domeną telecombts.pl. Dokładamy starań, aby Twoje dane były
        bezpieczne i wykorzystywane wyłącznie w zakresie niezbędnym do realizacji celów, dla których
        zostały podane.
      </p>

      <Section title="1. Administrator danych">
        <p>
          Administratorem Twoich danych osobowych jest <strong>Telecom BTS sp. z o.o.</strong>
          z siedzibą w Warszawie, ul. Adama Mickiewicza 55, 01-625 Warszawa, wpisana do rejestru przedsiębiorców
          KRS pod numerem 0000872371, NIP 525-28-44-929, REGON 387672774.
        </p>
        <p>
          Kontakt w sprawach związanych z ochroną danych osobowych:
          <a href="mailto:biuro@telecombts.pl" className="text-emerald-700 hover:underline ml-1">biuro@telecombts.pl</a>,
          tel. <a href="tel:+48512929641" className="text-emerald-700 hover:underline">+48 512 929 641</a>.
        </p>
      </Section>

      <Section title="2. Zakres zbieranych danych">
        <p>W formularzu kontaktowym zbieramy następujące dane osobowe:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>imię i nazwisko,</li>
          <li>numer telefonu,</li>
          <li>adres lub lokalizacja nieruchomości (działki),</li>
          <li>zgoda na przetwarzanie danych osobowych.</li>
        </ul>
        <p>
          Dodatkowo, jeśli wyrazisz na to zgodę, możemy zbierać dane analityczne dotyczące korzystania
          z serwisu (zob. <a href="/cookies" className="text-emerald-700 hover:underline">Polityka cookies</a>).
        </p>
      </Section>

      <Section title="3. Cel i podstawa prawna przetwarzania">
        <p>Twoje dane przetwarzamy w następujących celach:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>kontakt zwrotny i przygotowanie wstępnej wyceny dzierżawy — na podstawie Twojej zgody (art. 6 ust. 1 lit. a RODO),</li>
          <li>prowadzenie korespondencji i obsługi zapytania — na podstawie naszego prawnie uzasadnionego interesu (art. 6 ust. 1 lit. f RODO),</li>
          <li>spełnienie obowiązków księgowych i podatkowych, jeśli dojdzie do podpisania umowy — na podstawie obowiązku prawnego (art. 6 ust. 1 lit. c RODO),</li>
          <li>statystyka i poprawa jakości serwisu — na podstawie zgody wyrażonej w bannerze cookies.</li>
        </ul>
      </Section>

      <Section title="4. Okres przechowywania danych">
        <p>
          Dane zgromadzone w formularzu przechowujemy przez okres niezbędny do realizacji celu, dla którego
          zostały zebrane, nie dłużej jednak niż <strong>24 miesiące</strong> od ostatniego kontaktu —
          chyba że dłuższe przechowywanie wynika z obowiązków prawnych (np. księgowych) lub jest niezbędne
          do dochodzenia roszczeń.
        </p>
      </Section>

      <Section title="5. Odbiorcy danych">
        <p>Twoje dane możemy udostępniać:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>podmiotom wspierającym nas w realizacji usług (dostawcy hostingu, podwykonawcy audytu lokalizacji, kancelarie prawne),</li>
          <li>organom państwowym, jeśli wynika to z obowiązku prawnego.</li>
        </ul>
        <p>
          Nie sprzedajemy Twoich danych. Nie przekazujemy ich do państw trzecich poza Europejski Obszar
          Gospodarczy bez Twojej wyraźnej zgody.
        </p>
      </Section>

      <Section title="6. Twoje prawa">
        <p>Zgodnie z RODO przysługują Ci następujące prawa:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>prawo dostępu do swoich danych,</li>
          <li>prawo do sprostowania danych,</li>
          <li>prawo do usunięcia danych („prawo do bycia zapomnianym"),</li>
          <li>prawo do ograniczenia przetwarzania,</li>
          <li>prawo do przenoszenia danych,</li>
          <li>prawo wniesienia sprzeciwu,</li>
          <li>prawo do cofnięcia zgody w dowolnym momencie (bez wpływu na zgodność z prawem przetwarzania, którego dokonano przed cofnięciem),</li>
          <li>prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa).</li>
        </ul>
        <p>
          Aby skorzystać z powyższych praw, wystarczy napisać do nas na adres
          <a href="mailto:biuro@telecombts.pl" className="text-emerald-700 hover:underline ml-1">biuro@telecombts.pl</a>.
        </p>
      </Section>

      <Section title="7. Bezpieczeństwo danych">
        <p>
          Stosujemy środki techniczne i organizacyjne adekwatne do ryzyka, w tym szyfrowanie połączeń (SSL/TLS),
          kontrolę dostępu do systemów oraz regularne przeglądy bezpieczeństwa.
        </p>
      </Section>

      <Section title="8. Zmiany w polityce">
        <p>
          Zastrzegamy sobie prawo do wprowadzania zmian w niniejszej polityce prywatności. O istotnych zmianach
          poinformujemy poprzez stosowny komunikat na stronie głównej serwisu.
        </p>
      </Section>
    </LegalLayout>
  );
}
